import { render, staticRenderFns } from "./PrivatePolicy.vue?vue&type=template&id=e2e94222&"
import script from "./PrivatePolicy.vue?vue&type=script&lang=js&"
export * from "./PrivatePolicy.vue?vue&type=script&lang=js&"
import style0 from "./PrivatePolicy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports